/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FilterViewScope = {
    User: 'user'
} as const;
export type FilterViewScope = typeof FilterViewScope[keyof typeof FilterViewScope];


export function FilterViewScopeFromJSON(json: any): FilterViewScope {
    return FilterViewScopeFromJSONTyped(json, false);
}

export function FilterViewScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterViewScope {
    return json as FilterViewScope;
}

export function FilterViewScopeToJSON(value?: FilterViewScope | null): any {
    return value as any;
}

